const ApplianceImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/Sections/Img_Appliances.jpg";

const ClothingImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/Sections/Img_clothing%26Access.webp";

const ConstructionImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/Sections/Img_Construction.webp";

const ElectronicsImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/Sections/Img_electronics.webp";

const FilmPhotoImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/Sections/Img_filmPhoto.png";

const FurnitureImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/Sections/Img_Furniture.jpg";

const kidsAndBabiesImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/Sections/Img_kids%26Babies.jpg";

const NAImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/ImgNA.png";

const OutdoorImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/Sections/Img_Outdoor.jpg";

const PartyAndEventsImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/Sections/Img_Party%26Events.jpg";

const SportsAndFitnessImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/Sections/Img_Sports%26Fitness.jpeg";

const VehiclesImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/Sections/Img_Vehicles.webp";

const WfhImg =
  "https://equiprents-awsbucket.s3.ap-south-1.amazonaws.com/staticAssets/assets/Sections/Img_wfh.webp";

export {
  ApplianceImg,
  ClothingImg,
  ConstructionImg,
  ElectronicsImg,
  FilmPhotoImg,
  FurnitureImg,
  kidsAndBabiesImg,
  NAImg,
  OutdoorImg,
  PartyAndEventsImg,
  SportsAndFitnessImg,
  VehiclesImg,
  WfhImg,
};
